<template>
  <div class="hello container">
    <div class="mt-4">
      <h1>VSM - Aide</h1>
      <div>
        <h3>Connecter l'outil à Trello</h3>
        <p>
          Que ce soit pour associer une carte au VSM ou pour l'éditer via le formulaire il est impératif de
          permettre la connexion de son compte Trello avec le VSM. Pour cela il faut au préalable avoir autorisé
          l'affichage des pop ups pour voir le module de connexion à Trello.
        </p>
        <p>
          Si la page d'association ou d'édition vous indique 'En attente de connexion avec Trello' ou 'carte non
          trouvée', c'est sans doute que Trello n'est pas connecté, voici la procédure à suivre :
        </p>
        <ul>
          <li>ouvrir dans un nouvel onglet ou fenêtre la
            <router-link :to="{ name: 'Associate' }">page d'association</router-link>
          </li>
          <li>sur cette page d'association autoriser les pop up :
            <ul>
              <li>sous Firefox : dans la barre d'adresse cliquer sur l'icône <img
                src="https://prod-cdn.sumo.mozilla.net/uploads/gallery/images/Popup-blocked.png"> -> permissions ->
                'ouvrir des fenêtres pop up' -> mettre à autoriser
              </li>
              <li>sous Chrome/Chromium : dans la barre d'adresse cliquer sur l'icône <img
                src="https://prod-cdn.sumo.mozilla.net/uploads/gallery/images/Popup-blocked.png"> -> pop ups bloqués ->
                toujours autoriser -> ok
              </li>
              <li>sous Safari : suivre <a
                href="https://assistance.orange.fr/ordinateurs-peripheriques/installer-et-utiliser/la-recherche-et-navigation-sur-le-web-cookies/un-navigateur/safari-mac/cookies-securite/safari-mac-autoriser-les-fenetres-pop-up_163081-712169"
                target="_blank">cette procédure</a>, une fois Trello connecté vous pourrez remettre en place le blocage
                des pop ups de la même manière
              </li>
              <li>sous Brave : Brave ne <a href="https://github.com/brave/browser-laptop/issues/3752">supporte pas les
                pop ups pour le moment</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div>
        <h3>Associer une carte Trello au VSM</h3>
        <p><i>si la description de la carte indique un 'lien pour éditer cette carte', il n'est pas nécessaire de
          l'associer de nouveau, on l'édite directement en cliquant sur le lien, sinon : </i></p>
        <ul>
          <li>se rendre sur la
            <router-link :to="{ name: 'Associate' }">page d'association</router-link>
          </li>
          <li>Sélectionner la carte à associer :
            <ul>
              <li>le plus simple est de coller l'url de la carte à associer dans le champ 'Ajouter une carte avec
              son url', puis de cliquer sur soumettre</li>
              <li>alternative si la carte a été créé le jour même :
                <ul>
                  <li>cliquer sur 'Mise à jour' pour voir les cartes créées aujourd'hui</li>
                  <li>une fois la recherche terminée, si des cartes sont trouvées une liste déroulante est accessible
                  </li>
                  <li>sélectionner la carte à associer dans la liste</li>
                </ul>
              </li>
              <li>alternative si la carte est plus ancienne ou que la recherche du jour ne donne rien :
                <ul>
                  <li>dans 'rechercher une carte indiquer' le titre de la carte</li>
                  <li>au fur et à mesure des termes entrés des proposition de cartes s'affichent</li>
                  <li>cliquer sur le nom de la carte à associer</li>
                </ul>
              </li>
            </ul>
          </li>
          <li>dans tous les cas : une fois la carte voulue sélectionnée, vérifier le nom indiqué dans "association avec
            la carte" (au besoin cliquer sur le lien pour vérifier la carte dans Trello)
          </li>
          <li>si il s'agit de la bonne carte, cliquer sur Associer</li>
          <li>un message de confirmation s'affiche, si désiré cliquer sur 'éditer la carte' pour l'éditer tout de suite,
            sinon on pourra accéder au formulaire directement depuis la carte Trello
          </li>
        </ul>
        <ul>Remarques :
          <li>il n'est possible d'associer une carte qu'avec un seul sujet, l'association enverra un message d'erreur si
            on essaye de l'associer de nouveau
          </li>
          <li>il peut arriver que l'API Trello soit saturée et n'arrive pas à mettre à jour le contenu de la carte lors
            de l'association -> un message d'erreur s'affiche alors, comme indiqué il suffit de cliquer dessus pour
            relancer la mise à jour de la carte
          </li>
        </ul>
        <ul><strong>Attention !</strong>
          <li>une fois la carte associée à un sujet les éléments suivants il ne faut plus édier les éléments suivant
            depuis la carte Trello mais depuis le VSM
            <ul>
              <li>titre (sauf pour ajouter l'heure en début de titre, au format type 16h15 ou 16H15)</li>
              <li>description</li>
              <li>étiquette</li>
            </ul>
          </li>
          <li>mais il est toujours possible d'assigner des membres, des échéances, pièces jointes ou commentaires à une
            carte associée au VSM
          </li>
        </ul>
      </div>
      <div>
        <h3>Editer un sujet avec le VSM</h3>
        <p><i>la carte doit au préalable avoir été associée</i></p>
        <ul>
          <li>ouvrir la carte Trello et cliquer simplement sur le lien d'édition (au début de la description : 'lien
            pour éditer cette carte'
          </li>
          <li>la page d'édition s'ouvre</li>
          <li>par défaut on arriver sur l'onglet 'résumé', au besoin se rendre sur un autre onglet suivant les
            modifications à apporter
          </li>
          <li>remplir les données voulues dans le formulaire, et cliquer sur ' pour valider les modification</li>
          <li>les informations sont automatiquement mises à jour sur la carte</li>
        </ul>
      </div>
      <div>
        <h3>Bugs, questions, remarques ?</h3>
        <p>faire un commentaire à Alexis via Trello -> @alexisraphaeloff</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Hello',
    data() {
      return {
        msg: 'Vostok'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Hello.vue